/**
 * Defines a service locator. Use for dependency injection.
 */
import { bindAll } from 'shared/decorators';

@bindAll
export class ServiceLocator {
    services = {};

    /**
     * Adds a named service
     * @param name
     * @param value
     */
    register (name, value) {
      this.services[name] = value;
    }

    /**
     * Removes the service requested by "name"
     * @param name
     */
    unregister (name) {
      delete this.services[name];
    }

    /**
     * Locates the service requested by "name"
     * @param name
     * @returns {*}
     */
    resolve (name) {
      if (this.services[name]) {
        return this.services[name];
      }
      throw new Error(`Service "${name}" was not found.`);
    }

    /**
     * Clears all services.
     */
    empty () {
      Object.keys(this.services).forEach(k => this.unregister(k));
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/ServiceLocator.js